import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function sliderTeam() {
    document.addEventListener( 'DOMContentLoaded', function () {
        const blocks = document.querySelectorAll('.blockSliderTeam__sliders');
      if(blocks){
        blocks.forEach(block=>{
            new Splide(block, {
              perPage: 3,
              perMove: 1,
              autoplay: false,
              interval: 3000,
              pagination: false,
              arrows: true,

              breakpoints: {
                1200: {
                  perPage : 2,
                  perMove : 1,
                },
                992: {
                  perPage : 4,
                  perMove : 1,
                  arrows: true,
                },
                768: {
                  perPage : 3,
                  perMove : 1,
                },
                520: {
                  perPage : 2,
                  perMove : 1,
                  arrows: true,
                }
              }
              }).mount();
        });
      }
    })
}